import { labelsToValues } from 'src/utils/labels-to-values';

export type RawProductState =
  | 'UPLOADED'
  | 'SUBMITTED'
  | 'FINISHED'
  | 'CANCELLED';

const rawProductStateLabels: Record<RawProductState, string> = {
  UPLOADED: 'Uploaded',
  SUBMITTED: 'Submitted',
  FINISHED: 'Finished',
  CANCELLED: 'Cancelled',
};

export const rawProductStateValues = labelsToValues(rawProductStateLabels);
